
import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'

import ShoppingCart from '../components/ShoppingCart.vue'

const Products = namespace('products')
const Cart = namespace('cart')

@Component({
  name: 'ProductPage',
  components: {
    ShoppingCart,
  },
})
export default class ProductPage extends Vue {
  lightboxVisible = false
  lightboxImage = ''
  lightboxIndex = 0

  @Products.Getter getById: any
  @Products.Getter getShopSize: any
  @Products.Getter getConfigCombinations: any
  @Products.Getter getConfigIds: any
  @Products.Action getAllProducts: any
  @Products.Action addNewProduct: any
  @Products.Action addNewConfigCombinations: any
  @Products.Action addNewConfigIds: any
  @Cart.Action addProductToCart: any
  get myCarousel(): any {
    return this.$refs.carousel
  }

  get product() {
    return this.getById(this.$route.params.id)
  }

  get configCombinations() {
    return this.getConfigCombinations()
  }

  get configIds() {
    return this.getConfigIds()
  }

  get shopSize() {
    return this.getShopSize()
  }

  get config() {
    let str = ''
    for (let i = 0; i < this.product.checkList.length; i++) {
      const element = this.product.checkList[i]
      str += element
    }
    return str
  }

  get SummaryPrice() {
    let sum = 0
    for (let i = 0; i < this.product.checkList.length; i++) {
      const element = this.product.checkList[i]
      sum += this.product.configurator[element]
    }
    return this.product.price + sum
  }

  created() {
    this.getAllProducts()
  }

  getTitle(product) {
    if (typeof product.title === 'object') {
      return product.title[this.$i18n.locale] || product.title.ua || product.title.en || ''
    }
    return product.title
  }

  getDescription(product) {
    if (product.description && typeof product.description === 'object') {
      return product.description[this.$i18n.locale] || product.description.ua || product.description.en || ''
    }
    return product.description || ''
  }

  getOptionName(option) {
    if (option.name && typeof option.name === 'object') {
      return option.name[this.$i18n.locale] || option.name.ua || option.name.en || ''
    }
    return option.name || ''
  }

  getImageSrc(image) {
    if (!image) return ''
    if (image.startsWith('http') || image.startsWith('/')) {
      return image
    }
    try {
      return require(`@/assets/img/${image}`)
    } catch (e) {
      return ''
    }
  }

  setActiveItem(index) {
    this.myCarousel.setActiveItem(index)
  }

  lightboxEl: any = null

  openLightbox(image) {
    this.lightboxIndex = this.product.images.indexOf(image)
    this.lightboxVisible = true
    document.body.style.overflow = 'hidden'
    this.renderLightbox()
  }

  closeLightbox() {
    this.lightboxVisible = false
    document.body.style.overflow = ''
    if (this.lightboxEl) {
      document.body.removeChild(this.lightboxEl)
      this.lightboxEl = null
    }
  }

  lightboxPrev() {
    this.lightboxIndex = (this.lightboxIndex - 1 + this.product.images.length) % this.product.images.length
    this.renderLightbox()
  }

  lightboxNext() {
    this.lightboxIndex = (this.lightboxIndex + 1) % this.product.images.length
    this.renderLightbox()
  }

  renderLightbox() {
    if (this.lightboxEl) document.body.removeChild(this.lightboxEl)

    const el = document.createElement('div')
    el.className = 'lightbox'
    el.onclick = () => this.closeLightbox()

    const img = document.createElement('img')
    img.src = this.getImageSrc(this.product.images[this.lightboxIndex])
    img.onclick = (e) => e.stopPropagation()
    el.appendChild(img)

    if (this.product.images.length > 1) {
      const prev = document.createElement('button')
      prev.className = 'lightbox-prev'
      prev.innerHTML = '&#8249;'
      prev.onclick = (e) => { e.stopPropagation(); this.lightboxPrev() }
      el.appendChild(prev)

      const next = document.createElement('button')
      next.className = 'lightbox-next'
      next.innerHTML = '&#8250;'
      next.onclick = (e) => { e.stopPropagation(); this.lightboxNext() }
      el.appendChild(next)
    }

    const close = document.createElement('button')
    close.className = 'lightbox-close'
    close.innerHTML = '&times;'
    close.onclick = () => this.closeLightbox()
    el.appendChild(close)

    document.body.appendChild(el)
    this.lightboxEl = el
  }

  beforeDestroy() {
    if (this.lightboxEl) {
      document.body.removeChild(this.lightboxEl)
      this.lightboxEl = null
    }
    document.body.style.overflow = ''
  }

  contains(arr, arr2) {
    if (arr.length != arr2.length) {
      return false
    }
    let on = 0
    for (let i = 0; i < arr.length; i++) {
      for (let j = 0; j < arr2.length; j++) {
        if (arr[i] === arr2[j]) {
          on++
          break
        }
      }
    }
    return on == arr.length ? true : false
  }

  addThisProductToCart(product) {
    if (product.checkList.length > 0) {
      let doWeHaveConfig = false
      for (let i = 0; i < this.configCombinations.length; i++) {
        if (this.contains(this.configCombinations[i], this.config)) {
          this.addProductToCart(this.getById(this.configIds[i]))
          doWeHaveConfig = true
          break
        }
      }

      if (!doWeHaveConfig) {
        const newProduct = {
          id: this.shopSize + 1,
          title: this.getTitle(product),
          price: product.price,
          inventory: product.inventory,
          images: product.images,
          configurator: product.configurator,
          checked: product.checked,
          checkList: product.checkList,
          totalPrice: this.SummaryPrice,
        }
        this.addNewConfigCombinations(this.config)
        this.addNewConfigIds(this.shopSize + 1)
        this.addNewProduct(newProduct)
        this.addProductToCart(newProduct)
      }
    } else {
      this.addProductToCart(product)
    }

    // Тост
    ;(this as any).$notify({
      title: this.getTitle(product),
      message: String(this.$t('shop.addedToCart')),
      type: 'success',
      offset: 160,
      duration: 2500,
    })

    // Короткочасна зелена підсвітка кнопки
    const btn = this.$el.querySelector('.btn-add-to-cart')
    if (btn) {
      btn.classList.add('btn-flash')
      setTimeout(() => { btn.classList.remove('btn-flash'); (btn as HTMLElement).blur() }, 400)
    }
  }
}
